
<mat-card class="contact_holder">
   
    <mat-accordion class="contacts" [multi]="true">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Owner
          </mat-panel-title>
        </mat-expansion-panel-header>

        <button *ngIf="Owners.length==0" mat-icon-button color="primary" class="addbtn" [ngClass]="{'actived': addnewContact}"
         (click)="addOwner(ownerAdd,false,false,'')">
         <mat-icon>add</mat-icon>
        </button>
        
      <div *ngFor="let c of Owners" class="bcard" fxLayout="row">
          <div class="picinfo">
              <div class="userpic" (click)="contactDetail(c)">
                  <img *ngIf="c.imageUrl!=''" src="{{c.imageUrl}}" alt="">
                  <span *ngIf="c.imageUrl==''" class="username" >
                      {{c.shortName}}
                    </span>
              </div>
              <div class="info">
                  <h4 >{{c.name}}</h4>
                  <app-email-phone [data]="c"></app-email-phone>

              </div>
          </div>    
          <mat-icon class="del" (click)="deleteSelectedContact(c.companyID,c.contactID,c.contactCompanyUserMapID)">delete</mat-icon>    
      </div>
  
      <div *ngIf="Owners.length == 0" class="noContact">
        No Owner added yet.
      </div>
      </mat-expansion-panel>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ContactName}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <button mat-icon-button color="primary" class="addbtn" [ngClass]="{'actived': addnewContact}" (click)="addShare(shareAdd,false,false,'')"><mat-icon>add</mat-icon></button>
          
        <div *ngFor="let c of NormalContacts" class="bcard" fxLayout="row">
            <div class="picinfo">
                <div class="userpic" (click)="contactDetail(c)">
                    <img *ngIf="c.imageUrl!=''" src="{{c.imageUrl}}" alt="">
                    <span *ngIf="c.imageUrl==''" class="username" >
                        {{c.shortName}}
                      </span>
                </div>
                <div class="info">
                  <div class="nameBlock">
                    <h4 (click)="contactDetail(c)">{{c.name}}</h4>
                    <div class="portalTag">

                     
                      <mat-checkbox color="primary" [checked]="c.isPortalAccess"
                      (change)="accessOnPortal($event,c)"  matTooltip="Portal  Access" >
                     </mat-checkbox>

                     <button  mat-icon-button class="PlusRole" color="accent" (click)="addShare(RoleAddEdit,false,true,c)" 
                     matTooltip="Add Relation">
                      <mat-icon>add</mat-icon>
                    </button>

                    </div>
                  </div>
                    
                    <app-email-phone [data]="c"></app-email-phone>
                   
                     
                   
                    <div class="chips">
                        <mat-chip-list aria-label="">
                          <ng-container *ngFor="let transRole of c.contactCompanyRoleMappingModels; index as i">
                            <mat-chip>
                              {{transRole.rloeName}} <mat-icon matChipRemove (click)="deleteRole(transRole.contactCompanyRoleID,$event)">cancel</mat-icon>
                            </mat-chip>                            
                          </ng-container>
                          <!-- <button *ngIf="c.contactCompanyRoleMappingModels.length != 0"  mat-icon-button color="accent" (click)="addShare(RoleAddEdit,false,true,c)"><mat-icon>add</mat-icon></button> -->
                           
                        </mat-chip-list>                       
                    </div>
                    <!-- <ng-container *ngIf="c.contactCompanyRoleMappingModels.length == 0">
                      <button mat-button class="PlusRole" color="accent" (click)="addShare(RoleAddEdit,false,true,c)">Add Relation</button>
                    </ng-container> -->
                </div>
            </div>
            <mat-icon class="del" (click)="deleteSelectedContact(c.companyID,c.contactID,c.contactCompanyUserMapID)">cancel</mat-icon>
        </div>
    
        <div *ngIf="NormalContacts.length == 0" class="noContact">
          No {{ContactName}} added in list.
        </div>
        </mat-expansion-panel>

       
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Shared Access
            </mat-panel-title>
          </mat-expansion-panel-header>
          <button mat-icon-button color="primary" class="addbtn" [ngClass]="{'actived': addnewContact}" (click)="addShare(shareAdd,true,false,'')"><mat-icon>add</mat-icon></button>
          <div *ngFor="let c of SharedContacts" class="bcard" fxLayout="row">
            <div class="picinfo" >
                <div class="userpic" (click)="contactDetail(c)">
                    <img *ngIf="c.imageUrl!=''" src="{{c.imageUrl}}" alt="">
                    <span *ngIf="c.imageUrl==''" class="username" >
                        {{c.shortName}}
                      </span>
                </div>
                <div class="info">

                  <div class="nameBlock">
                    <h4 (click)="contactDetail(c)">{{c.name}}</h4>

                    <div class="portalTag">

                      
                        <button mat-icon-button class="PlusRole" color="accent" (click)="addShare(RoleAddEdit,true,true,c)"
                        matTooltip="Add Relation">
                          <mat-icon>add</mat-icon>
                        </button>
                    
                    </div>

                  </div>
                    
                  
                    <app-email-phone [data]="c"></app-email-phone>
                    <div class="chips">
                        <mat-chip-list aria-label="">
                            <ng-container *ngFor="let transRole of c.contactCompanyRoleMappingModels; index as i">
                                <mat-chip >
                                  {{transRole.rloeName}} <mat-icon matChipRemove (click)="deleteRole(transRole.contactCompanyRoleID,$event)">cancel</mat-icon>
                                </mat-chip>                            
                            </ng-container>
                           
                           
                       </mat-chip-list>                       
                    </div>
                    
                </div>
            </div>
            <mat-icon class="del" (click)="deleteSelectedContact(c.companyID,c.contactID,c.contactCompanyUserMapID)">delete</mat-icon>
        </div>
        <div *ngIf="SharedContacts.length == 0 && SharedRoleList.length == 0" class="noContact">
          No {{ContactName}} added in list.
        </div>

        <div *ngFor="let c of SharedRoleList" class="bcard" fxLayout="row">
          <div class="picinfo" >
              <div class="userpic">
                  <!-- <img *ngIf="c.imageUrl!=''" src="{{c.imageUrl}}" alt=""> -->
                  <span  class="username">
                      {{c.shortName}}
                    </span>
              </div>
              <div class="info">
                  <h4>{{c.name}}</h4>                
                
              </div>
          </div>
          <mat-icon class="del" (click)="deleteSelectedContact(c.companyID,c.contactID,c.contactCompanyUserMapID)">delete</mat-icon>
      </div>


        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{CoreName}}
            </mat-panel-title>
          </mat-expansion-panel-header>
        
          
        <div *ngFor="let c of NormalCore" class="bcard" fxLayout="row">
            <div class="picinfo">
                <div class="userpic" (click)="coreDetail(c)">
                    <img *ngIf="c.imageUrl!=''" src="{{c.imageUrl}}" alt="">
                    <span *ngIf="c.imageUrl==''" class="username" >
                        {{c.shortName}}
                      </span>
                </div>
                <div class="info">
                    <h4 (click)="coreDetail(c)">{{c.name}}</h4>
                    <app-email-phone [data]="c"></app-email-phone>                
                </div>
            </div>            
        </div>
    
        <div *ngIf="NormalCore.length == 0" class="noContact">
          No {{CoreName}} added in list.
        </div>
        </mat-expansion-panel>


      </mat-accordion>

</mat-card>


<ng-template #shareAdd>

    <h2 mat-dialog-title *ngIf="isShare">
       <span  class="groupIcon"><mat-icon>group_add</mat-icon></span>
        Add {{ContactName}} / User / Role
          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </h2>

        <h2 mat-dialog-title *ngIf="!isShare">
            <span  class="groupIcon"><mat-icon>group_add</mat-icon></span>
             Add {{ContactName}}
               <button mat-icon-button (click)="close()">
                 <mat-icon>close</mat-icon>
               </button>
        </h2>
    
  <mat-dialog-content class="mat-typography">   
    <div class="radOpts" *ngIf="isShare">
      <mat-radio-group aria-label="Select an option" color="primary">
        <mat-radio-button value="1" [checked]=true (click)="selectSharedAccessRb(1)">{{ContactName}}</mat-radio-button>
        <mat-radio-button value="3" (click)="selectSharedAccessRb(3)">User</mat-radio-button>
        <mat-radio-button value="2" (click)="selectSharedAccessRb(2)">Role</mat-radio-button>
      </mat-radio-group>
    </div>

    <app-contactlist *ngIf="!isSharedAccessRolePopup && isSharedAccessUserPopup==false" [objectList]="contactsList" [isSharedAccessRolePopup]="isSharedAccessRolePopup" [isRolePopup]="isRolePopup" (NotifyItemSelected)="contactSelected($event)" (NotifyListfetch)="getContactListCoreImplementation($event)"></app-contactlist>
    <app-contactlist *ngIf="isSharedAccessRolePopup && isSharedAccessUserPopup==false" [objectList]="sharedAccessRoleList" [isSharedAccessRolePopup]="isSharedAccessRolePopup" [isRolePopup]="isRolePopup" (NotifyItemSelected)="RoleSelectedForSharedAccess($event)" (NotifyListfetch)="getSharedAccessRoles($event)"></app-contactlist>
    <app-contactlist *ngIf="isSharedAccessUserPopup" [objectList]="sharedAccessUserList" [isReviewerPopup]="isSharedAccessUserPopup" [isRolePopup]="isRolePopup" (NotifyItemSelected)="userSelected($event)" (NotifyListfetch)="getUserListCoreImplementation($event)"></app-contactlist>
    
    <ul *ngIf="!isSharedAccessRolePopup" class="selectedlist">
      <li *ngFor="let user of peoples">
        <div class="userndetail">
            <div class="userpic">
              <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
              <span *ngIf="user.img==''" class="username">
                  {{user.shortName}}
                </span>
            </div>
            <div class="detail">
                <h4>{{user.name}}</h4>
                <p>{{user.email}}</p>
            </div>
            <div class="opt">
                <button mat-icon-button><mat-icon (click)="removeItem(user,isRolePopup)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>
    
    <ul *ngIf="isSharedAccessRolePopup" class="selectedlist">
      <li *ngFor="let role of selectedsharedAccessRole">
        <div class="userndetail">
            <div class="detail">
                <h4> {{role.name}}</h4>
            </div>
            <div class="opt">
                <button mat-icon-button ><mat-icon (click)="removeItemRoleSharedAccess(role,isSharedAccessRolePopup)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>
    
    <ul *ngIf="isSharedAccessUserPopup ==true" class="selectedlist">
      <li *ngFor="let user of userSelectedList">
        <div class="userndetail">
            <div class="userpic">
              <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
              <span *ngIf="user.img==''" class="username">
                  {{user.shortName}}
                </span>
            </div>
            <div class="detail">
                <h4>{{user.name}}</h4>
                <p>{{user.email}}</p>
            </div>
            <div class="opt">
                <button mat-icon-button><mat-icon (click)="removeUser(user)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>

  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!showAddButton (click)="addUpdateCompanyContact()">Done</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #ownerAdd>

  <h2 mat-dialog-title>
     <span  class="groupIcon"><mat-icon>group_add</mat-icon></span>
        Add Owner 
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
   </h2>     
  
<mat-dialog-content class="mat-typography">  
 
  <app-contactlist *ngIf="isSharedAccessUserPopup" [objectList]="sharedAccessUserList" [isReviewerPopup]="isSharedAccessUserPopup" [isRolePopup]="isRolePopup" (NotifyItemSelected)="userSelected($event)" (NotifyListfetch)="getUserListCoreImplementation($event)"></app-contactlist>

  <ul *ngIf="isSharedAccessUserPopup ==true" class="selectedlist">
    <li *ngFor="let user of userSelectedList">
      <div class="userndetail">
          <div class="userpic">
            <img *ngIf="user.img!=''" src="{{user.img}}" alt="">
            <span *ngIf="user.img==''" class="username">
                {{user.shortName}}
              </span>
          </div>
          <div class="detail">
              <h4>{{user.name}}</h4>
              <p>{{user.email}}</p>
          </div>
          <div class="opt">
              <button mat-icon-button><mat-icon (click)="removeUser(user)">cancel</mat-icon></button>
          </div>
      </div>
    </li>
  </ul>

</mat-dialog-content>
<mat-dialog-actions >
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]=!showAddButton (click)="addUpdateCompanyContact()">Done</button>
</mat-dialog-actions>
</ng-template>

  <ng-template #RoleAddEdit>
    <h2 mat-dialog-title>
       <span  class="groupIcon" ><mat-icon>group_add</mat-icon></span>
        Add Relation to {{currentRoleContact.name}}
          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </h2>
  <mat-dialog-content class="mat-typography">    

    <app-contactlist [objectList]="transRoleList" [isRolePopup]="isRolePopup" (NotifyItemSelected)="RoleSelected($event)"  (NotifyListfetch)="getTransactinalRoles($event)"></app-contactlist>
    
    <ul class="selectedlist">      
      <li *ngFor="let role of Roles">
        <div class="userndetail">            
            <div class="detail">
                <h4> {{role.transactionalRoleName}}</h4>
            </div>
            <div class="opt">
                <button mat-icon-button ><mat-icon (click)="removeItem(role,isRolePopup)">cancel</mat-icon></button>
            </div>
        </div>
      </li>
    </ul>
    
  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!showContactRoleAddButton (click)="addUpdateCompanyContactRole()">Done</button>
  </mat-dialog-actions>
  </ng-template>


 

  <app-addnew *ngIf="showAddContact" (closeAdd)="getClose($event)" [name]="searchName" (contactSaved)="getNormalAndSharedContacts()" [coreID]="companyID" 
  [isShared]="isShare" [mainModuleName]='mainModuleNameSenForAdd' [modulename]='Module' [ngClass]="{'open': showAddContact}" ></app-addnew>

  <app-details *ngIf="showDetail" [ngClass]="{ open: showDetail }" [transactionID]='TransactionId' [modulenames]='Module' 
  (closeDetail)="getCloseDetails($event)"></app-details>
